import { ContractTypesTable } from "components";

const ContractType = () => {
    return <ContractTypesTable />;
}

export default ContractType;
